import CrudCustom from '../../../libs/custom/CrudCustom';

let AkunPengenaanPajakService = new CrudCustom('/akun-pengenaan-pajaks');
export default AkunPengenaanPajakService;
